import { render } from "./ModalAddAccessType.vue?vue&type=template&id=3d1ae6c2"
import script from "./ModalAddAccessType.vue?vue&type=script&lang=js"
export * from "./ModalAddAccessType.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__